import React, {useContext} from "react";
import { AppContext } from "../../context/AppContext";
import "./containerRestauLight.css"
import { Link } from "react-router-dom";
import { buildRestaurantTypeLabel } from "../types/restaurantTypes";
import { formatRestaurantNote, GoldStar, isNewRestaurant, useRestaurantFavorite, useRestaurantLink } from "./hookContainerRestau";
import { HomeRestaurant } from "../types/types";
import { FaMapMarkerAlt } from "react-icons/fa";
import { HookHeartIcon } from "../../hookIcons/hookIconsHeart";


interface containerRestauLightProps {
    resto:HomeRestaurant,
    isHighlighted:boolean,
    priority?: boolean;
    eager?: boolean;
}

const ContainerRestauLightInner:React.FC<containerRestauLightProps> = ({resto,isHighlighted,priority=false,eager=false}) => {
    const {date_published,id_url,idrestaurant,devanture,address,visiblecity,note,name,type,type_display,price_range,def_cuisine} = resto;
    const {isLogin,setConnectionScreen,restoFav,setRestoFav} = useContext(AppContext)

    let isNew = isNewRestaurant(date_published);
    const linkResto = useRestaurantLink(address[1],name,id_url);

    const { fav, handleFav } = useRestaurantFavorite({idrestaurant,isLogin,restoFav,setRestoFav,setConnectionScreen,});

    let noteUse = formatRestaurantNote(note)


    return (
        <Link to={linkResto} state={{ skipSplash: true }} target="_blank" rel="noopener" className={`containerRestauLight primaryBack ${isHighlighted ? 'isHighlighted' : ''}`} id={`containerRestauLight`+idrestaurant} >
            <div className="containerDevanture">
                <div className="shadowImg"></div>
                <img src={devanture} loading={eager ? "eager" : "lazy"}  {...(priority && { fetchpriority: 'high' })}  decoding="async" alt={`${name} - ${visiblecity || address?.[1] || "restaurant"}`} width={300} height={171}/>
            </div>
            {isNew && <span className="isNew smallTextBold" >Nouveau</span>}
            <div className="separationGold"></div>
            <div className="footerContainerRestauLight smallText primaryBack" >
                <div className="containerFirstAndScnd">
                    <div className="leftPart">
                        <div className="firstLine midTextBold">
                            <h3 className='title' translate="no">{name}</h3>
                        </div>
                        <div className="scndLine smallText">
                            <h4 className="type" >{type_display ? type_display : buildRestaurantTypeLabel(type)}</h4>
                            
                        </div>
                    </div>
                    <div className="rightPart">
                        
                            <div className={`rate ${noteUse ? '' : 'rateHidden'}`}>
                                <span > {noteUse || 1}</span>
                                <GoldStar id={idrestaurant} className="star" size={20} />
                            </div>
                            <div className="price">
                                <p>{price_range[0] ?? 20} - {price_range[1] ?? 30} €</p> 
                            </div>
                    </div>
                </div>
                <div className="thirdLine smallText">
                    <FaMapMarkerAlt className="icon" color="#737373" />
                    {visiblecity ? visiblecity : address[1]}
                </div>
                {def_cuisine && <div className="fourthLine smallText">
                    <span className="cuisineText">“{def_cuisine}”</span>
                </div>}
            </div> 
            {   
                isLogin !== 2 && <div className="heart flexAllCenter pointer" onClick={(e) => {e.preventDefault();e.stopPropagation();handleFav()}}>
                    <HookHeartIcon className=" lowOpacityHover pointer"  color={!fav ? "#fdfcfc" : "#f00"}  size={25}/>
                </div>
            }
        </Link>  
    )
}
const ContainerRestauLight = React.memo(ContainerRestauLightInner);

export { ContainerRestauLight }